import { useSearchParams } from "react-router-dom";
import { Alert, Button, Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const PaymentStatus = () => {
	const [searchParams] = useSearchParams();
	const status = searchParams.get("status");
	const navigate = useNavigate();

	const handleGoHome = () => {
		navigate("/dashboard");
	};

	return (
		<Container className="d-flex vh-100">
			<Row className="m-auto align-self-center w-100">
				<Col md={{ span: 6, offset: 3 }}>
					{status === "success" ? (
						<Alert variant="success" className="text-center p-5 shadow">
							<Alert.Heading>Payment Successful!</Alert.Heading>
							<p>
								Your payment has been processed successfully. Thank you for your
								purchase!
							</p>
							<hr />
							<Button variant="success" onClick={handleGoHome}>
								Go to Home
							</Button>
						</Alert>
					) : (
						<Alert variant="danger" className="text-center p-5 shadow">
							<Alert.Heading>Payment Failed</Alert.Heading>
							<p>
								Unfortunately, your payment could not be processed. Please try
								again or contact support.
							</p>
							<hr />
							<Button variant="danger" onClick={handleGoHome}>
								Go to Home
							</Button>
						</Alert>
					)}
				</Col>
			</Row>
		</Container>
	);
};

export default PaymentStatus;
